'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTextareaAutosize = require('react-textarea-autosize');

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _onlinepbxWarning = require('../onlinepbx-warning');

var _onlinepbxWarning2 = _interopRequireDefault(_onlinepbxWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlinepbxTableTextarea = function (_React$Component) {
  _inherits(OnlinepbxTableTextarea, _React$Component);

  function OnlinepbxTableTextarea(props) {
    _classCallCheck(this, OnlinepbxTableTextarea);

    var _this = _possibleConstructorReturn(this, (OnlinepbxTableTextarea.__proto__ || Object.getPrototypeOf(OnlinepbxTableTextarea)).call(this, props));

    _this.state = {
      isFocus: false,
      value: null
    };
    return _this;
  }

  _createClass(OnlinepbxTableTextarea, [{
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        if (this.state.isFocus !== prevState.isFocus) {
          this.textarea.scrollTop = 0;
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            placeholder = _props.placeholder,
            title = _props.title,
            warningText = _props.warningText,
            _props$value = _props.value,
            value = _props$value === undefined ? '' : _props$value,
            _onChange = _props.onChange,
            length = _props.length,
            maxLength = _props.maxLength,
            disabled = _props.disabled,
            _onBlur = _props.onBlur,
            filterValue = _props.filterValue;

        return _react2['default'].createElement(
          'div',
          {
            title: title,
            className: 'onlinepbx__lib__table__textarea' },
          _react2['default'].createElement(_reactTextareaAutosize2['default'], {
            placeholder: placeholder,
            onKeyDown: function () {
              function onKeyDown(evt) {
                if (evt.keyCode === 13) {
                  evt.preventDefault();
                }
              }

              return onKeyDown;
            }(),
            disabled: disabled,
            maxLength: maxLength,
            value: this.state.value === null ? value : this.state.value,
            onChange: function () {
              function onChange(evt) {
                _this2.setState({ value: typeof filterValue === 'function' ? filterValue(evt.target.value) : evt.target.value });
                typeof _onChange === 'function' && _onChange(evt);
              }

              return onChange;
            }(),
            onFocus: function () {
              function onFocus() {
                return _this2.setState({ isFocus: true });
              }

              return onFocus;
            }(),
            onBlur: function () {
              function onBlur(evt) {
                _this2.setState({ isFocus: false, value: null });
                typeof _onBlur === 'function' && _onBlur(evt);
              }

              return onBlur;
            }(),
            inputRef: function () {
              function inputRef(node) {
                if (node) {
                  _this2.textarea = node;
                }
              }

              return inputRef;
            }(),
            className: (0, _classnames2['default'])('onlinepbx__lib__table__textarea__field', {
              'onlinepbx__lib__table__textarea__field__active': this.state.isFocus && ((this.state.value === null ? value : this.state.value) || '').length > length,
              'onlinepbx__lib__table__textarea__field__disabled': disabled,
              'onlinepbx__lib__table__textarea__field__error': warningText
            }) }),
          warningText && _react2['default'].createElement(_onlinepbxWarning2['default'], {
            text: warningText
          })
        );
      }

      return render;
    }()
  }]);

  return OnlinepbxTableTextarea;
}(_react2['default'].Component);

exports['default'] = OnlinepbxTableTextarea;